import React from 'react';
import './ProposalGenerator/ProposalBox.css';

const InstallationLocAddress = ({ location, id }) => {
  const { name, serviceAdress } = location;
  return (
    <tr>
      <td>{name || ''}</td>
      <td>{serviceAdress || ''}</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  );
};

export default InstallationLocAddress;
